/**
 * Retreive cookie.
 */

import 'core-js/fn/regexp/escape'

export function getCookie(key) {
  const regex = new RegExp(`(?:^|;)(?:\\s*)${RegExp.escape(key)}=([^;]+)`)
  const match = document.cookie.match(regex)

  if (match && match[1]) {
    return decodeURIComponent(match[1])
  }

  return null
}


export function doNotSell() {
  return JSON.parse(getCookie('do_not_sell'))
}
